'use strict';

var _ = require('lodash');

function observeHeight() {
    var $banner = $('#onetrust-banner-sdk');
    var height = 0;

    if ($banner.is(':visible')) {
        height = $banner.height();
    }

    return height;
}

module.exports = {
    repositionFixedElementsOnResize: function () {
        var localeCode = $('.current-locale').val();
        var $positionBasedOnOneTrust = $('.js-position-based-on-one-trust');

        if (typeof zE === 'function') {
            zE('webWidget', 'setLocale', localeCode); // eslint-disable-line
        }

        var $window = $(window);

        // Reposition sticky elements
        $window.on('resize', _.debounce(function () {
            if (typeof zE === 'function') { // eslint-disable-line
                zE('webWidget', 'updateSettings', { // eslint-disable-line
                    webWidget: {
                        offset: {
                            vertical: observeHeight() + 'px',
                            mobile: {
                                vertical: observeHeight() + 'px'
                            }
                        }
                    }
                });
            }

            if ($positionBasedOnOneTrust.length > 0) {
                $positionBasedOnOneTrust.css('bottom', observeHeight() + 'px');
            }
        }, 200));
    },
    repositionFixedElements: function () {
        var $positionBasedOnOneTrust = $('.js-position-based-on-one-trust');

        // Reposition sticky elements
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach((mutation) => {
                //otFlat - class used to identify the modal container
                if ($(mutation.target).hasClass('otFlat')) {
                    var $oneTrustModal = $(mutation.target);

                    if ($oneTrustModal.is(':visible')) {
                        // Reposition chat icon
                        if (typeof zE === 'function') { // eslint-disable-line
                            zE('webWidget', 'updateSettings', { // eslint-disable-line
                                webWidget: {
                                    offset: {
                                        vertical: ($oneTrustModal.height()) + 'px',
                                        mobile: {
                                            vertical: ($oneTrustModal.height()) + 'px'
                                        }
                                    }
                                }
                            });
                        }

                        // Reposition sticky elements
                        if ($positionBasedOnOneTrust.length > 0) {
                            $positionBasedOnOneTrust.css('bottom', observeHeight() + 'px');
                        }
                    } else {
                        // Reposition chat icon
                        if (typeof zE === 'function') { // eslint-disable-line
                            zE('webWidget', 'updateSettings', { // eslint-disable-line
                                webWidget: {
                                    offset: {
                                        vertical: '0px',
                                        mobile: {
                                            vertical: '0px'
                                        }
                                    }
                                }
                            });
                        }

                        // Reposition sticky elements
                        if ($positionBasedOnOneTrust.length > 0) {
                            $positionBasedOnOneTrust.css('bottom', '0px');
                        }

                        observer.disconnect();
                    }
                }
            });
        });

        observer.observe(document, {
            attributes: true,
            childList: true,
            characterData: false,
            subtree: true,
            attributeFilter: ['style', 'class']
        });

        // Set fixed elements position in case the OneTrust script is already in DOM.
        var $otModal = $('#onetrust-banner-sdk');

        if ($otModal.length > 0 && $otModal.is(':visible')) {
            if (typeof zE === 'function') { // eslint-disable-line
                zE('webWidget', 'updateSettings', { // eslint-disable-line
                    webWidget: {
                        offset: {
                            vertical: ($otModal.height()) + 'px',
                            mobile: {
                                vertical: ($otModal.height()) + 'px'
                            }
                        }
                    }
                });
            }

            if ($positionBasedOnOneTrust.length > 0) {
                $positionBasedOnOneTrust.css('bottom', observeHeight() + 'px');
            }
        }
    }
};

